<template>
  <div class="modal-parent">
    <loading
      v-model:active="loading"
      :can-cancel="true"
      :is-full-page="true"
      color="#669933"
      loader="spinner"
    />
    <section class="header">
      <div class="" style="margin: 0 auto; width: 96%">
        <div class="header-content">
          <div class="section-1">
            <h5 class="modal-caption">Add New User</h5>
          </div>

          <div class="section-2">
            <div class="logo-container">
              <img src="../../../assets/releaf-logo.png" alt="" />
            </div>

            <div class="icon-container">
              <div
                class="close-container"
                style="cursor: pointer"
                @click="closeModal"
              >
                <img src="../../../assets/x-icon.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- border -->
    <div class="border"></div>

    <!-- Form section -->
    <section class="form-section">
      <form class="form">
        <TextInput
          placeholder="First Name"
          @onInputChange="handleInputChange"
          fieldName="first_name"
          :inputValue="userForm?.first_name"
        />
        <TextInput
          placeholder="Last Name"
          @onInputChange="handleInputChange"
          fieldName="last_name"
          :inputValue="userForm?.last_name"
        />
        <TextInput
          placeholder="Email"
          @onInputChange="handleInputChange"
          fieldName="email"
          :inputValue="userForm?.email"
        />
        <Dropdown
          :options="roles"
          class="select"
          dropdownTitle="Role"
          fieldName="userType"
          fieldValue="name"
          @onSelect="handleSelect"
          :inputValue="userForm?.userType"
        />

      </form>
    </section>

    <div class="button-container">
      <GreenButton width="12rem" label="Add user" @click="addNewUser" />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { createToast } from "mosha-vue-toastify";
import TextInput from "../../../components/form-inputs/text-input/TextInput.vue";
import GreenButton from "../../../components/buttons/green-button/GreenButton.vue";
import Dropdown from "../../../components/form-inputs/select-dropdown/Dropdown.vue";

export default {
  name: "AddUserModal",

  components: {
    TextInput,
    GreenButton,
    Dropdown,
    Loading,
  },

  data() {
    return {
      userForm: {
        first_name: "",
        last_name: "",
        email: "",
        userType: "",
      },
      roles: [],
      loading: false,

      isRefresh: false,
    };
  },

  mounted() {
    this.fetchUserRoles();
  },

  methods: {

    async fetchUserTypes() {
      try {
        let response = await this.$store.dispatch(
            "userManagement/fetchUserType"
        );

        this.userTypes = response.map(this.getUserTypeName)

      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    getUserTypeName(userTypes){
      return userTypes.name;
    },
    closeModal() {
      this.$emit("onCloseModal", false);
    },

    handleSelect(obj) {
      this.userForm = {
        ...this.userForm,
        ...obj,
      };

      console.log(this.userForm);
    },
    handleInputChange(obj) {
      this.userForm = {
        ...this.userForm,
        ...obj,
      };
    },

    async fetchUserRoles() {
      this.roles = await this.$store.dispatch("roles/getUserRoles");
    },

    async addNewUser() {
      const { first_name, last_name, email, userType } = this.userForm;
      if (!first_name || !last_name || !email || !userType) {
        return createToast("All fields are required!", {
          type: "danger",
          timeout: 2000,
          position: "top-left",
        });
      }

      try {
        this.loading = true;
        const newUser = await this.$store.dispatch(
          "userManagement/addNewUser",
          this.userForm
        );

        if (newUser) {
          this.loading = false;
          createToast("A new user added successfully!", {
            type: "success",
            timeout: 3000,
            position: "top-right",
            onClose: () => {
              this.$store.dispatch("userManagement/setRefresh", true);
              this.closeModal();
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.modal-parent {
  background-color: white;
  height: 100%;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px;
  /* border: 1px solid #000; */
}

.section-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid red; */
  width: 40%;
}

p {
  color: #232a34;
  font-weight: 900;
  align-self: center;
  font-size: 0.77rem;
  margin-top: 7px;
}

.section-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid red; */
  width: 55%;
}

.modal-caption {
  color: #232a34;
  font-weight: 700;
}

.logo-container {
  background-color: #232a34;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid green;
}

.logo-container img {
  width: 30px;
  height: auto;
}

.icon-container {
  display: flex;
  justify-content: space-between;
}

.close-container {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: #dcdbdb;
}

.close-container:hover {
  background: #e8e8e8;
}

.border {
  margin-top: 10px;
  border-bottom: 1px solid #b3b3b3;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 4% auto 2% auto;
}
</style>
